import { Injectable } from '@angular/core';
import { ToastrService } from "ngx-toastr";

@Injectable({
  providedIn: 'root'
})
export class ToastService {


  constructor(private toastr: ToastrService) {
  }

  public showSuccess(message: string, title = ''): void {
    this.toastr.success(message, title);
  }

  public showError(message: string, title = ''): void {
    this.toastr.error(message, title);
  }

  public showInfo(message: string, title = ''): void {
    this.toastr.info(message, title);
  }

}
